import React, { lazy, useCallback } from 'react';
import { RememberedAccount } from '../../../reducers/login-reducer';
import { useBaseLoginV2Model } from '../hooks/useBaseLoginV2Model';
import { useRememberMe } from '../hooks/useRememberMe';

const BaseRememberedAccountsPage = lazy(() => import('./BasePage'));

const V2RememberedAccountsPage = () => {
  const rememberMe = useRememberMe({ loginStateSource: 'v2' });
  const { checkUsername } = useBaseLoginV2Model({ autoCheckUsername: false });
  const onAccountSelected = useCallback(
    (account: RememberedAccount) => checkUsername(account.email, true),
    [checkUsername]
  );

  return <BaseRememberedAccountsPage {...rememberMe} onAccountSelected={onAccountSelected} />;
};

export default V2RememberedAccountsPage;
